import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { intial_api, SendQuestionAns, AnsSingleValue, AnsDoubleValue, InitialSymptomsRequest, CreateICDRequest, requestICD, RosWithsymtoms } from 'src/app/models/symtomChecker/symptomsChecker';
import { Router } from '@angular/router';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SymptomsCheckerService } from 'src/app/services/symptoms-checker.service';
import { PatientPersonalInfo } from 'src/app/models/verifypatient/verifypatient';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
declare var $: any;
@Component({
  selector: 'app-symptomsquestions',
  templateUrl: './symptomsquestions.component.html',
  styleUrls: ['./symptomsquestions.component.css']
})
export class SymptomsquestionsComponent implements OnInit {
  pageNum:any;
  totalPages:any;
  iniatobj  =new intial_api();
  initial_question_options : any;
  InitialQuestionResponce: any;
  InitialSymptomsRequest : any;
  patientPersonalInfo : any;
  settings:any;
  @ViewChild('scrollMe') private myScrollContainer: ElementRef;
  constructor(private translateService: TranslateService, private router:Router,private phrUtils:PhrutillsService,private SymptomsCheckerService:SymptomsCheckerService,private spinner: NgxSpinnerService,
    private datepipe: DatePipe) { 
      this.CreateICDRequest = new CreateICDRequest;
      this.SendQuestionAns = new SendQuestionAns();
      this.AnsSingleValue = new AnsSingleValue();
      this.InitialSymptomsRequest = new InitialSymptomsRequest();
      let info = localStorage.getItem('PersonalInfo');
      if(!info){
        this.router.navigateByUrl("/");
        return;
      }
      let havSetting = localStorage.getItem("financialCheck");
      if(havSetting){
        this.settings = JSON.parse(this.phrUtils.decrypt(havSetting));
        if(this.settings.data.enable_Symston_Checker.toLowerCase() !="true")
        {
          this.CheckPreviousRoute();
        }
      }
      this.patientPersonalInfo = this.phrUtils.decrypt(info) as PatientPersonalInfo;
      let pagesorder=localStorage.getItem('pagesorder');
      this.pageNum =JSON.parse(pagesorder?pagesorder:'').symptoms_checker;
      this.totalPages=localStorage.getItem('totalPages');
    }
    
  ngOnInit(): void {
   // this.phrUtils.setTitle('symptomsQuestions');
      this.scrollToTop();
      this.iniatobj.has_patient_active_med= true;
      this.iniatobj.last_icds_and_labs= "" ;
      this.iniatobj.patient_account= this.patientPersonalInfo.PATIENT_ACCOUNT;
      this.iniatobj.patient_dob= this.datepipe.transform(this.patientPersonalInfo.DOB, 'MM/dd/yyyy');
      this.iniatobj.patient_gender= this.patientPersonalInfo.GENDER;
      this.iniatobj.patient_rov= this.patientPersonalInfo.REASON_NAME;
      this.iniatobj.practice_code= this.patientPersonalInfo.PRACTICE_CODE;
      this.iniatobj.provider_code= this.patientPersonalInfo.PROVIDER_CODE;
    this.iniatobj.will_intake_form_show= true;
    let visitdate = localStorage.getItem('visitDate')
    if (visitdate) {
      this.iniatobj.dos = localStorage.getItem('visitDate');
    } else {
      this.iniatobj.dos ="";
    }
      this.spinner.show();
      let lang = localStorage.getItem('language');
      if (!lang)
        lang = 'en';
      this.SymptomsCheckerService.initialQuestions(this.iniatobj,lang).subscribe((res:any)=>{
        this.spinner.hide();
        localStorage.setItem("AccessTokenSymptoms",res.access_token);
        this.InitialQuestionResponce = res.payload ;
        if(this.InitialQuestionResponce.screen =="model_screen")
        {
          if(this.patientPersonalInfo.GENDER.toLowerCase() == "male" || this.patientPersonalInfo.GENDER.toLowerCase() == "unk")
          {
            window.location.href = window.location.origin + '/patient/symptomsmale';
           //this.router.navigateByUrl("/patient/symptomsmale");
          }else
          {
           window.location.href = window.location.origin + '/patient/symptomsfemale';
            //this.router.navigateByUrl("/patient/symptomsfemale");
          }
        }
        else if(this.InitialQuestionResponce.screen == "skip")
        {
          this.submitTheInitailSymptoms();
        }
        this.initial_question_options = this.InitialQuestionResponce.question_options.Form_Order;
      },(error :any)=>
      {
        this.spinner.hide();
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtils.showError(text);
       // this.phrUtils.showError("Service is not available, please try later.")
      })
    if (this.InitialQuestionResponce?.screen == 'result_screen') {
      this.phrUtils.setTitle('HPI');
    } else {
      this.phrUtils.patientlanguage$.subscribe(language => {
        console.log("dafault " + language);
        if (language === 'es') {
          this.phrUtils.setTitle('Formularios de admisión');
        } else if (language === 'hi') {
          this.phrUtils.setTitle('सेवन प्रपत्र');
        }
        else if (language === 'ur') {
          this.phrUtils.setTitle('انٹیک فارمز');
        } 
        else {
          this.phrUtils.setTitle('Intake Forms');
        }
      });
     
    }
    }
    SendQuestionAns : any;
    AnsSingleValue : any;
    AnsDoubleValue : AnsDoubleValue[]=[];
    inputNumerValue(event:any)
    {
      event.target.value=event.target.value.replace(/\D/g, '');
      let AnsDoubleValuedummy = new AnsDoubleValue();
      AnsDoubleValuedummy.key = event.target.name;
      AnsDoubleValuedummy.value = event.target.value;
      $('[id="'+event.target.name+'"]').css('color','inherit');
      if(this.AnsDoubleValue.length !=0)
      {
        let symptomName = this.AnsDoubleValue.filter(res => res.key == event.target.name);
        if(symptomName.length == 0)
        {
          this.AnsDoubleValue.push(AnsDoubleValuedummy);
        }
        else
        {
          this.AnsDoubleValue.map(res =>{
            if(res.key == event.target.name)
            {
              res.value = event.target.value;
            }
          })
        }
      }
      else
      {
        this.AnsDoubleValue.push(AnsDoubleValuedummy);
      }
    }
    inputtextvalue(event:any)
    {
      let AnsDoubleValuedummy = new AnsDoubleValue();
      AnsDoubleValuedummy.key = event.target.name;
      AnsDoubleValuedummy.value = event.target.value;
      $('[id="'+event.target.name+'"]').css('color','inherit');
      if(this.AnsDoubleValue.length !=0)
      {
        let symptomName = this.AnsDoubleValue.filter(res => res.key == event.target.name);
        if(symptomName.length == 0)
        {
          this.AnsDoubleValue.push(AnsDoubleValuedummy);
        }
        else
        {
          this.AnsDoubleValue.map(res =>{
            if(res.key == event.target.name)
            {
              res.value = event.target.value;
            }
          })
        }
      }
      else 
      {
        this.AnsDoubleValue.push(AnsDoubleValuedummy);
      }
    }
    changeDropDownSelection(event : any)
    {
      let AnsDoubleValuedummy = new AnsDoubleValue();
      AnsDoubleValuedummy.key = event.target.name;
      AnsDoubleValuedummy.drop_down = event.target.value;
      $('[id="'+event.target.name+'"]').css('color','inherit');
      if(this.AnsDoubleValue.length !=0)
      {
        let symptomName = this.AnsDoubleValue.filter(res => res.key == event.target.name);
        if(symptomName.length == 0)
        {
          this.AnsDoubleValue.push(AnsDoubleValuedummy);
        }
        else
        {
          this.AnsDoubleValue.map(res =>{
            if(res.key == event.target.name)
            {
              res.drop_down = event.target.value;
            }
          })
        }
      }
      else 
      {
        this.AnsDoubleValue.push(AnsDoubleValuedummy);
      }
    }
    changeradioSelection(event : any)
    {
      let AnsDoubleValuedummy = new AnsDoubleValue();
      AnsDoubleValuedummy.key = event.target.name;
      AnsDoubleValuedummy.value = event.target.value;
      $('[id="'+event.target.name+'"]').css('color','inherit');
      if(this.AnsDoubleValue.length !=0)
      {
        let symptomName = this.AnsDoubleValue.filter(res => res.key == event.target.name);
        if(symptomName.length == 0)
        {
          this.AnsDoubleValue.push(AnsDoubleValuedummy);
        }
        else
        {
          this.AnsDoubleValue.map(res =>{
            if(res.key == event.target.name)
            {
              res.value = event.target.value;
            }
          })
        }
      }
      else 
      {
        this.AnsDoubleValue.push(AnsDoubleValuedummy);
      }
    }
    dynamicquestionnotselecteddate:any;
    changeCalenderSelection(event : any)
    {
      let AnsDoubleValuedummy = new AnsDoubleValue();
      AnsDoubleValuedummy.key = event.target.name;
      AnsDoubleValuedummy.value = event.target.value;
      if(this.AnsDoubleValue.length !=0)
      {
        let symptomName = this.AnsDoubleValue.filter(res => res.key == event.target.name);
        if(symptomName.length == 0)
        {
          if(event.target.id=='Effective Date01')
          {
            if(!$('[id="'+event.target.name+'00'+'"]').val())
            {
              $('#questionnotselecteddate').modal('show');
              this.dynamicquestionnotselecteddate='Please first select effective form date.';
              $('[id="'+event.target.name+'01'+'"]').val('');
              return;
            }
          }
          else
          {
            $('[id="'+event.target.name+'"]').css('color','inherit');
            $('[id="'+event.target.name+'01'+'"]').attr({"min" : $('[id="'+event.target.name+'00'+'"]').val()});
            this.AnsDoubleValue.push(AnsDoubleValuedummy);
          }
        }
        else
        {
          this.AnsDoubleValue.map(res =>{
            if(res.value || res.key == event.target.name)
            {
              let dummyvlaue = res.value.split(',');
              if(res.key == event.target.name && dummyvlaue.length == 1)
              {
                if(event.target.id=='Effective Date00')
                {
                  res.value = event.target.value;
                  $('[id="'+event.target.name+'01'+'"]').attr({"min" : $('[id="'+event.target.name+'00'+'"]').val()});
                  //remove error message
                  $('[id="'+event.target.name+'"]').css('color','inherit');
                }
                else if(event.target.id=='Effective Date01')
                {
                  if(new Date($('[id="'+event.target.name+'00'+'"]').val()) < new Date($('[id="'+event.target.name+'01'+'"]').val()))
                  {
                    res.value = res.value+','+event.target.value;
                  }
                  else
                  {
                    $('#questionnotselecteddate').modal('show');
                    this.dynamicquestionnotselecteddate='Effective To date should be later than Effective From.';
                    $('[id="'+event.target.name+'01'+'"]').val('');
                    return;
                  }
                }
              }
              else if(res.key == event.target.name && dummyvlaue.length == 2)
              {
                if(event.target.id=='Effective Date00')
                {
                  if(new Date($('[id="'+event.target.name+'00'+'"]').val()) < new Date($('[id="'+event.target.name+'01'+'"]').val()))
                  {
                    res.value = event.target.value+','+dummyvlaue[1];
                    $('[id="'+event.target.name+'01'+'"]').attr({"min" : $('[id="'+event.target.name+'00'+'"]').val()});
                  }
                  else
                  {
                    $('#questionnotselecteddate').modal('show');
                    this.dynamicquestionnotselecteddate='Effective To date should be later than Effective From.';
                    $('[id="'+event.target.name+'01'+'"]').val('');
                    res.value = event.target.value;
                    $('[id="'+event.target.name+'01'+'"]').attr({"min" : $('[id="'+event.target.name+'00'+'"]').val()});
                    return;
                  }
                }
                else if(event.target.id=='Effective Date01')
                {
                  if(new Date($('[id="'+event.target.name+'00'+'"]').val()) < new Date($('[id="'+event.target.name+'01'+'"]').val()))
                  {
                    res.value = dummyvlaue[0]+','+event.target.value;
                  }
                  else
                  {
                    $('#questionnotselecteddate').modal('show');
                    this.dynamicquestionnotselecteddate='Effective To date should be later than Effective From.';
                    $('[id="'+event.target.name+'01'+'"]').val('');
                    res.value = dummyvlaue[0];
                    $('[id="'+event.target.name+'01'+'"]').attr({"min" : $('[id="'+event.target.name+'00'+'"]').val()});
                    return;
                  }
                }
              }
            }
          })
        }
      }
      else 
      {
        if(event.target.id=='Effective Date01')
        {
          if(!$('[id="'+event.target.name+'00'+'"]').val())
          {
            $('#questionnotselecteddate').modal('show');
            this.dynamicquestionnotselecteddate='Please first select effective form date.';
            $('[id="'+event.target.name+'01'+'"]').val('');
            return;
          }
        }
        else
        {
          $('[id="'+event.target.name+'"]').css('color','inherit');
          $('[id="'+event.target.name+'01'+'"]').attr({"min" : $('[id="'+event.target.name+'00'+'"]').val()});
          this.AnsDoubleValue.push(AnsDoubleValuedummy);
        } 
      }
    }
    changeCheckBoxSelection(event : any)
    {
      let AnsDoubleValuedummy = new AnsDoubleValue();
      AnsDoubleValuedummy.key = event.target.name;
      AnsDoubleValuedummy.value = event.target.value;
      $('[id="'+event.target.name+'"]').css('color','inherit');
      if(this.AnsDoubleValue.length !=0)
      {
        let symptomName = this.AnsDoubleValue.filter(res => res.key == event.target.name);
        if(symptomName.length == 0)
        {
          this.AnsDoubleValue.push(AnsDoubleValuedummy);
        }
        else
        {
          this.AnsDoubleValue.map(res =>{
            if(res.value || res.key == event.target.name)
            {
              let dummyvlaue = res.value.split(',');
              let filtervalue = dummyvlaue.filter((resdummy:any) => resdummy == event.target.value);
              if(res.key == event.target.name && filtervalue.length ==0 && event.target.value.toLowerCase() !='none')
              {
                let filtervalueNone = dummyvlaue.filter((resdummy:any) => resdummy.toLowerCase() == 'none');
                if(filtervalueNone.length>0)
                {
                  res.value = event.target.value;
                  let Noneid = this.InitialQuestionResponce.question_options[event.target.name][0].values.length-1;
                  $('[id="'+event.target.name+'0'+Noneid+'"]').prop("checked", false);
                }
                else
                {
                  res.value = res.value+','+event.target.value;
                }
              }
              else if(res.key == event.target.name && filtervalue.length != 0 && event.target.value.toLowerCase() !='none')
              {
                let ansValues = res.value.split(',');
                res.value ='';
                if(ansValues.length > 0)
                {
                  ansValues.map((res1:any) =>{
                    if(res1 != event.target.value)
                    {
                      if(res.value=='')
                      res.value = res1;
                      else
                      res.value = res.value+','+res1;
                    }
                  })
                }else
                {
                  res.value ='';
                }
              }
              else if(res.key == event.target.name && event.target.value.toLowerCase() =='none' && filtervalue.length == 0)
              {
                res.value = event.target.value;
                let lastid = event.target.id.split('0').pop();
                if(lastid == '')
                lastid = '10';
                for(let i=0; i<+lastid; i++)
                {
                  $('[id="'+event.target.name+'0'+i+'"]').prop("checked", false);
                }
              }
              else if(res.key == event.target.name && event.target.value.toLowerCase() =='none' && filtervalue.length != 0)
              {
                res.value ='';
              }
            }
          })
        }
      }
      else 
      {
        this.AnsDoubleValue.push(AnsDoubleValuedummy);
      }
    }
    answerarray : any = '';
    
    submitTheInitailSymptoms()
    {
      if(this.InitialQuestionResponce.screen == 'result_screen' || this.InitialQuestionResponce.screen == 'skip')
      {
        if(this.InitialQuestionResponce.screen == 'result_screen')
        {
          this.GenerateICD();
        }
        else if(this.InitialQuestionResponce.screen == 'skip')
        {
          this.CheckPreviousRoute();
        }
      }
      let AnsRequired = 0;
      this.SendQuestionAns = new SendQuestionAns();
      if(this.AnsDoubleValue.length != 0)
      {
        this.initial_question_options.map((res:any) => {
          let questionFound = this.AnsDoubleValue.filter(res1 => res1.key==res && res1.value!='');
          
          let questionFoundwithDropDown = this.InitialQuestionResponce.question_options[res].filter((res3:any) => (res3.type=='dropdown'));
          if(questionFoundwithDropDown.length != 0)
          {
            questionFoundwithDropDown = this.InitialQuestionResponce.question_options[res].filter((res3:any) => (res3.type=='number'));
          }
          
          if(questionFoundwithDropDown.length != 0)
          {
            if(!questionFound[0]?.value || !questionFound[0]?.drop_down)
            {
              $('[id="'+res+'"]').css('color','#f10707');
              $('[id="'+res+'"]').css('font-weight','600');
              $('#questionnotselectedmodel').modal('show');
              AnsRequired ++;
            }
            else
            {
              $('[id="'+res+'"]').css('color','inherit');
            }
          }
          else
          if(questionFound.length == 0)
          {
            $('[id="'+res+'"]').css('color','#f10707');
            $('[id="'+res+'"]').css('font-weight','600');
            // $('[id="'+res+'"]').css('padding-left','5px');
            
            //  color: #f10707;
            //  font-weight: 600;
            $('#questionnotselectedmodel').modal('show');
            //$('[id="'+res+'"]').css('color','red');
            AnsRequired ++;
          }
          else
          {
            $('[id="'+res+'"]').css('color','inherit');
          }
        })
        if(AnsRequired > 0)
        {
          return;
        }
        this.SendQuestionAns.patient_account = this.patientPersonalInfo.PATIENT_ACCOUNT.toString();
        this.AnsDoubleValue.map(res =>{
          if(res.drop_down && res.value)
          {
            let val = res.value;
            let dropdownvalue= res.drop_down;
            this.SendQuestionAns.answer[res.key] = {'value' : val , 'value_dropdown' : dropdownvalue}
          }
          else if(res.drop_down && !res.value)
          {
            let dropdownvalue= res.drop_down;
            this.SendQuestionAns.answer[res.key] = {'value_dropdown' : dropdownvalue}
          }
          else if(!res.drop_down && res.value)
          {
            let val = res.value;
            this.SendQuestionAns.answer[res.key] = {'value' : val}
          } 
        })
        this.SendQuestionAns.answer["symptom"] = {'value' : this.InitialQuestionResponce.title}
        this.spinner.show();
        let lang = localStorage.getItem('language');
        if (!lang)
          lang = 'en';

        this.SymptomsCheckerService.symptom_info(this.SendQuestionAns,this.InitialQuestionResponce.destination_url,lang).subscribe((res:any) =>{
          this.scrollToTop();
          this.spinner.hide();
          this.InitialQuestionResponce = res;
          if (this.InitialQuestionResponce?.screen == 'result_screen') {
            this.phrUtils.setTitle('HPI');
          } else {
            this.phrUtils.patientlanguage$.subscribe(language => {
              console.log("dafault " + language);
              if (language === 'es') {
                this.phrUtils.setTitle('Formularios de admisión');
              } else if (language === 'hi') {
                this.phrUtils.setTitle('सेवन प्रपत्र');
              }
              else if (language === 'ur') {
                this.phrUtils.setTitle('انٹیک فارمز');
              } 
              else {
                this.phrUtils.setTitle('Intake Forms');
              }
            });
          }
          if(this.InitialQuestionResponce.screen =="model_screen")
          {
            window.location.href = window.location.origin + '/patient/symptomsfemale';
            //this.router.navigateByUrl("/patient/symptomsfemale");
          }
          this.initial_question_options = this.InitialQuestionResponce.question_options.Form_Order;
          this.AnsDoubleValue = [];
          
        },(error:any)=>{
          this.spinner.hide();
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this.phrUtils.showError(text);
         // this.phrUtils.showError('Service is not available, please try later.')
        })
      }
      else
      {
        this.initial_question_options.map((res:any) => {
          // $('[id="'+res+'"]').css('color','#ff000024');
          // $('[id="'+res+'"]').css('border-radius','5px');
          // $('[id="'+res+'"]').css('padding-left','5px');
          
          $('[id="'+res+'"]').css('color','#f10707');
          $('[id="'+res+'"]').css('font-weight','600');
          $('#questionnotselectedmodel').modal('show');
          //$('[id="'+res+'"]').css('color','red');
        })
        return;
      }
      
    }
    startover()
    {
      this.iniatobj.has_patient_active_med= true;
      this.iniatobj.last_icds_and_labs= "" ;
      this.iniatobj.patient_account= this.patientPersonalInfo.PATIENT_ACCOUNT;
      this.iniatobj.patient_dob= this.datepipe.transform(this.patientPersonalInfo.DOB, 'MM/dd/yyyy');
      this.iniatobj.patient_gender= this.patientPersonalInfo.GENDER;
      this.iniatobj.patient_rov= this.patientPersonalInfo.REASON_NAME;
      this.iniatobj.practice_code= this.patientPersonalInfo.PRACTICE_CODE;
      this.iniatobj.provider_code= this.patientPersonalInfo.PROVIDER_CODE;
      this.iniatobj.will_intake_form_show= true;
      this.spinner.show();

      let lang = localStorage.getItem('language');
      if (!lang)
        lang = 'en';

      this.SymptomsCheckerService.start_over(this.iniatobj, lang).subscribe((res:any)=>{
        this.spinner.hide();
        localStorage.setItem("AccessTokenSymptoms",res.access_token);
        this.InitialQuestionResponce = res.payload ;
        if(this.InitialQuestionResponce.screen =="model_screen")
        {
          if(this.patientPersonalInfo.GENDER.toLowerCase() == "male" || this.patientPersonalInfo.GENDER.toLowerCase() == "unk")
          {
            window.location.href = window.location.origin + '/patient/symptomsmale';
            //this.router.navigateByUrl("/patient/symptomsmale");
          }else
          {
           window.location.href = window.location.origin + '/patient/symptomsfemale';
            //this.router.navigateByUrl("/patient/symptomsfemale");
          }
        }
        else if(this.InitialQuestionResponce.screen == "skip")
        {
          this.submitTheInitailSymptoms();
        }
        this.initial_question_options = this.InitialQuestionResponce.question_options.Form_Order;
      },(error :any)=>
      {
        this.spinner.hide();
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtils.showError(text);
        //this.phrUtils.showError("Service is not available, please try later.")
      })
    }
    backclick()
    {
      this.router.navigateByUrl('patient/insurance');
    }
    CreateICDRequest : any ;
    RosWithsymtoms : any = [];
    GenerateICD()
    {
      let request : any = new requestICD();
      if(this.InitialQuestionResponce.result.sym_to_ros)
      {
        let sym_to_ros = JSON.parse(this.InitialQuestionResponce.result.sym_to_ros.replace(/\\/g, ""))
        sym_to_ros.map((res : any) =>{
          let Ros = new RosWithsymtoms();
          Ros.category_subCategory = res.Category_SubCategory;
          res.Symptoms.map((res1:any) =>
          {
            Ros.symptoms.push(res1)
          })  
          this.RosWithsymtoms.push(Ros);
        })
      }
      request.ICDS = this.InitialQuestionResponce.result.ICDS;
      request.SUMMARY = this.InitialQuestionResponce.result.Summary;
      request.DOB = this.InitialQuestionResponce.result.DOB;
      //request.DOS = this.InitialQuestionResponce.result.DOS;
      let visitdate = localStorage.getItem('visitDate')
      if (visitdate) {
        request.DOS = localStorage.getItem('visitDate');
      } else {
        request.DOS = this.InitialQuestionResponce.result.DOS;
      }
     
      request.PROVIDER_CODE = this.InitialQuestionResponce.result.ProviderCode;
      request.PRACTICE_CODE = this.InitialQuestionResponce.result.PracticeCode;
      request.TRANSACTION_ID = this.InitialQuestionResponce.result.TransactionId;
      request.PATIENT_ACCOUNT = this.InitialQuestionResponce.result.PatientAccount;
      request.CREATED_DATE = this.InitialQuestionResponce.result.CreatedDate;
      request.MODIFIED_DATE = this.InitialQuestionResponce.result.ModifiedDate;
      request.DELETED = this.InitialQuestionResponce.result.Deleted ? 1 : 0;
      request.R_CODES = this.InitialQuestionResponce.result.RCodes;
      request.DIP_HTML = this.InitialQuestionResponce.result.dip_html?this.InitialQuestionResponce.result.dip_html:'',
      request.RISK_HTML = this.InitialQuestionResponce.result.risk_html?this.InitialQuestionResponce.result.risk_html:'';
      request.SYM_TO_ROS = this.InitialQuestionResponce.result.sym_to_ros?this.InitialQuestionResponce.result.sym_to_ros:'';
      if(this.InitialQuestionResponce.result.sym_to_ros)
      {
        this.RosWithsymtoms.map((res:any) =>
        {
          request.ROS_CAT_WITH_SYM.push(res);
        })
      }
      this.CreateICDRequest = new CreateICDRequest();
      this.CreateICDRequest.request.push(request);
      this.spinner.show();

      let lang = localStorage.getItem('language');
      if (!lang)
        lang = 'en';

      this.SymptomsCheckerService.IcdPredictionSaveData(this.CreateICDRequest,lang).subscribe((res:any) =>{
        this.spinner.hide();
        //comment success message on next page
        //this.phrUtils.showSuccess(res.RESPONSE.message);
        localStorage.setItem("backFromCovid","false");
        this.router.navigateByUrl('patient/intake');
      },(error :any)=>{
        this.spinner.hide();
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtils.showError(text);
        //this.phrUtils.showError("Service is not available, please try later.");
      });
    }
    CheckPreviousRoute()
    {
      if(localStorage.getItem('backfromintake') == 'true')
      {
        this.router.navigateByUrl('patient/insurance');
      }
      else
      {
        localStorage.setItem("backFromCovid","false");
        this.router.navigateByUrl('patient/intake');
        return;
      }
    }
    scrollToTop(): void {
      try {
        this.myScrollContainer.nativeElement.scrollTop = '0';
      } catch(err) { }                 
    }
  }
